import React, { Suspense, lazy } from "react";
import { Navigate, Route } from "react-router-dom";

/* Loaded on demand: the module carries its own store and mock dataset, which have no
   business in the main bundle of a build where the flag is off. */
const CommissionsPage = lazy(() => import("./screens/commissions/CommissionsPage"));
const FinancePage = lazy(() => import("./screens/commissions/FinancePage"));
const CommercialAccessPage = lazy(() => import("./screens/access/CommercialAccessPage"));
const ProposalDocPage = lazy(() => import("./screens/docs/ProposalDocPage"));
const LegalReviewQueue = lazy(() => import("./screens/legal/LegalReviewQueue"));
const MetricsPage = lazy(() => import("./screens/metrics/MetricsPage"));
const PortfolioRoute = lazy(() => import("./screens/portfolio/PortfolioRoute"));
const PendingPage = lazy(() => import("./screens/pending/PendingPage"));
const ServicesPage = lazy(() => import("./screens/services/ServicesPage"));
const InitiativeWorkspace = lazy(() => import("./screens/workspace/InitiativeWorkspace"));
const SalesMotionLayout = lazy(() => import("./shell/SalesMotionLayout"));

const withSuspense = (element: React.ReactElement) => (
	<Suspense fallback={null}>{element}</Suspense>
);

// prototype: B0
/**
 * KE Sales Motion route table, mounted under the dashboard AppLayout by
 * PrivateRoutes only when `isSalesMotionEnabled()`. The index is each side's
 * home (PortfolioRoute: the pipeline, or the customer's projects) and
 * `pending` what waits on the viewer, for both sides.
 * Screens that list more than the viewer's own account guard themselves.
 * The prototype's `/doc/:id/:kind` lives at /sales-motion/doc/:id/:kind,
 * outside the module's in-page layout as in the prototype.
 */
export const salesMotionRoutes = [
	<Route key="sales-motion-doc" path="sales-motion/doc/:id/:kind" element={withSuspense(<ProposalDocPage />)} />,
	<Route key="sales-motion" path="sales-motion" element={withSuspense(<SalesMotionLayout />)}>
		<Route index element={withSuspense(<PortfolioRoute />)} />
		<Route path="pending" element={withSuspense(<PendingPage />)} />
		{/* Earlier homes of legal (the pipeline) and of a customer's project list: both live at the index now. */}
		<Route path="pipeline" element={<Navigate to="/sales-motion" replace />} />
		<Route path="projects" element={<Navigate to="/sales-motion" replace />} />
		<Route path="i/:id" element={withSuspense(<InitiativeWorkspace />)} />
		<Route path="services" element={withSuspense(<ServicesPage />)} />
		<Route path="metrics" element={withSuspense(<MetricsPage />)} />
		<Route path="metrics/:id" element={withSuspense(<MetricsPage />)} />
		<Route path="legal" element={withSuspense(<LegalReviewQueue />)} />
		<Route path="access" element={withSuspense(<CommercialAccessPage />)} />
		<Route path="commissions" element={withSuspense(<CommissionsPage />)} />
		<Route path="finance" element={withSuspense(<FinancePage />)} />
		<Route path="*" element={<Navigate to="/sales-motion" replace />} />
	</Route>,
];
